import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";


const images = [
  "images/bg.webp",
  "images/slider1.jpeg",
//   "/images/slider3.jpg",
//   "/images/slider4.jpg",
];

// split image into pieces for explode effect
const createPieces = (rows, cols, src) => {
  const pieces = [];
  const w = 100 / cols;
  const h = 100 / rows;

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      pieces.push({
        id: `${r}-${c}`,
        src,
        style: {
          backgroundImage: `url(${src})`,
          backgroundSize: `${cols * 100}% ${rows * 100}%`,
          backgroundPosition: `${c * -100}% ${r * -100}%`,
          width: `${w}%`,
          height: `${h}%`,
        },
      });
    }
  }
  return pieces;
};

function Slider() {
  const [index, setIndex] = useState(0);
  const [explode, setExplode] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setExplode(true);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % images.length);
        setExplode(false);
      }, 800); // explosion duration
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const pieces = createPieces(4, 6, images[index]); // 4x6 grid

  return (
    <div className="relative w-full max-w-3xl mx-auto h-[400px] overflow-hidden rounded-2xl shadow-lg">
      <div className="w-full h-full flex flex-wrap">
        {pieces.map((piece) => (
          <motion.div
            key={piece.id}
            style={piece.style}
            className="bg-cover bg-no-repeat"
            initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
            animate={
              explode
                ? {
                    x: (Math.random() - 0.5) * 400,
                    y: (Math.random() - 0.5) * 400,
                    opacity: 0,
                    rotate: (Math.random() - 0.5) * 180,
                  }
                : { x: 0, y: 0, opacity: 1, rotate: 0 }
            }
            transition={{ duration: 0.8 }}
          />
        ))}
      </div>
    </div>
  );
}

export default Slider;
